import srraf from "srraf"
import EVENTS from "./events.js"

const breakpoints = [480, 720, 960, 1024, 1200, 1400]
const reversedBreakpoints = breakpoints.reverse()

const widthWatcher = () => {
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  let lastSize = viewportWidth

  srraf(({ vw }) => {
    document.dispatchEvent(new CustomEvent(EVENTS.WINDOW_RESIZED))

    if (vw > lastSize) {
      breakpoints.forEach((width) => {
        if (lastSize < width && vw >= width) {
          document.dispatchEvent(
            new CustomEvent(EVENTS.WINDOW_ABOVE_BREAKPOINT(width)),
          )
        }
      })
    } else {
      reversedBreakpoints.forEach((width) => {
        if (lastSize > width && vw < width) {
          document.dispatchEvent(
            new CustomEvent(EVENTS.WINDOW_BELOW_BREAKPOINT(width)),
          )
        }
      })
    }

    if (vw !== lastSize) {
      document.dispatchEvent(new CustomEvent(EVENTS.WINDOW_WIDTH_CHANGED))
    }

    lastSize = vw
  })
}

export default widthWatcher
